/**
 * Convert requestState object into a query string and encode it
 * @param {object} requestState
 * @return {string}
 */
const convertRequestStateToSearchParams = (requestState) => {
    const requestId = requestState?.requestId;
    const notificationToken = requestState?.notificationToken;

    // Encode the query string.
    const queryParams = new URLSearchParams();
    if (requestId) {
        queryParams.append('requestId', requestId);
    }
    if (notificationToken) {
        queryParams.append('notificationToken', notificationToken);
    }

    return queryParams.toString();
};

export default convertRequestStateToSearchParams;
